import { VivElement, defineComponent } from './base.js';

type ButtonVariant = 'primary' | 'secondary' | 'ghost' | 'danger';

/**
 * `<viv-button variant="primary" icon="fa-check" [disabled] [type=submit]>Label</viv-button>`
 * Renders a themed button in light DOM; forwards clicks unless disabled.
 */
export class VivButton extends VivElement {
    static get observedAttributes(): string[] {
        return ['variant', 'icon', 'disabled', 'type'];
    }

    private button: HTMLButtonElement | null = null;

    protected render(): void {
        const label = this.textContentFromSlot();
        const variant = (this.attr('variant', 'primary') as ButtonVariant);
        const icon = this.attr('icon');
        const disabled = this.hasFlag('disabled');
        const type = (this.attr('type', 'button')) as 'button' | 'submit' | 'reset';

        if (!this.button) {
            this.button = document.createElement('button');
            this.innerHTML = '';
            this.appendChild(this.button);
        }
        this.button.type = type;
        this.button.disabled = disabled;
        this.button.className = `vivBtn vivBtn--${variant}`;
        this.button.innerHTML = `${icon ? `<i class="fas ${icon}" aria-hidden="true"></i>` : ''}<span>${escapeText(label)}</span>`;
    }

    private textContentFromSlot(): string {
        const cached = this.getAttribute('data-viv-label');
        if (cached !== null) return cached;
        const text = (this.textContent || '').trim();
        this.setAttribute('data-viv-label', text);
        return text;
    }
}

function escapeText(value: string): string {
    return value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

export function registerVivButton(): void {
    defineComponent('viv-button', VivButton);
}
